// Pure rules for the planet lists' Compact/Full view preference, shared by
// the owned PLANETS list and the travel-phase CHOOSE PLANET list.
//
// The preference is stored per DEVICE CLASS: phones keep the original
// localStorage keys (so nobody's saved choice is lost) and default to
// compact; desktop gets its own `-desktop` keys and defaults to the full
// card, so the condensed view is an opt-in there. Keeping the classes apart
// means a window resized across the phone boundary switches to that class's
// own saved choice instead of dragging one preference across both layouts.

export const COMPACT_PLANETS_KEY = 'pg-compact-planets'
export const COMPACT_TRAVEL_KEY = 'pg-compact-travel'

/** The localStorage key holding a list's choice for the current device class. */
export function compactPrefKey(baseKey: string, isMobile: boolean): string {
  return isMobile ? baseKey : `${baseKey}-desktop`
}

/**
 * A stored preference resolved to a boolean. Anything that is not an explicit
 * 'true'/'false' (nothing saved yet, or a mangled value) falls back to the
 * device default: compact on phones, full-size cards on desktop.
 */
export function parseCompactPref(stored: string | null | undefined, isMobile: boolean): boolean {
  if (stored === 'true') {
    return true
  }
  if (stored === 'false') {
    return false
  }
  return isMobile
}

/**
 * Whether a planet list renders in compact mode: the player's toggle for THAT
 * list, and at least two compact-eligible cards — a lone card has nothing to
 * sit beside, so it stays a full card. The buy-phase CHOOSE ACTION list never
 * compacts (its cards carry purchase context the compact card doesn't show).
 */
export function isCompactListActive(
  owned: boolean,
  isPurchase: boolean,
  compactOwnedView: boolean,
  compactTravelView: boolean,
  eligibleCount: number,
): boolean {
  if (eligibleCount < 2) {
    return false
  }
  if (owned) {
    return compactOwnedView
  }
  return !isPurchase && compactTravelView
}
